import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

import FormSummaryItem from './FormSummaryItem.vue';
import { FormSection } from '@/models';
import { i18n } from '@/i18n/i18n';
import { computed, PropType } from 'vue';
import { useSmartFormStore } from '@/stores/smartForm.store';


export default /*#__PURE__*/_defineComponent({
  props: {
  section: {
    type: Object as PropType<FormSection>,
    required: true
  },

  formSubmissionId: {
    type: String,
    required: true
  },

  level: {
    type: Number,
    default: 0
  },

  card: {
    type: Boolean,
    default: true
  },

  locale: {
    type: String,
    default: i18n.global.locale.value
  }
},
  setup(__props) {

const props = __props



const smartForm = useSmartFormStore();

const conditionsMet = computed(() =>
  smartForm.getItemConditionsMet(props.formSubmissionId, props.section.conditions)
);

return (_ctx: any,_cache: any) => {
  const _component_FormSummarySection = _resolveComponent("FormSummarySection", true)!

  return (_unref(conditionsMet))
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(["flex flex-col space-y-4", {
      'bg-white p-10 rounded-lg border border-gray-200 shadow': __props.level === 0 && __props.card
    }])
      }, [
        (__props.section.heading)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent('h' + (__props.level + 2)), {
              key: 0,
              class: _normalizeClass(["font-semibold text-gray-900", __props.level ? 'text-base leading-normal mt-4' : 'text-xl mb-4'])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.section.heading), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (item.type === 'section')
              ? (_openBlock(), _createBlock(_component_FormSummarySection, {
                  key: 0,
                  section: item,
                  "form-submission-id": __props.formSubmissionId,
                  level: __props.level + 1,
                  locale: __props.locale
                }, null, 8, ["section", "form-submission-id", "level", "locale"]))
              : (_openBlock(), _createBlock(FormSummaryItem, {
                  key: item.id,
                  item: item,
                  "form-submission-id": __props.formSubmissionId,
                  locale: __props.locale
                }, null, 8, ["item", "form-submission-id", "locale"]))
          ], 64))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}
}

})